export type SignupSearch = {
  signupType?: string;
  promoCode?: string;
} & Record<string, unknown>;

/**
 * Validate the `/signup` search params.
 *
 * Unknown keys pass through untouched — TanStack strips any key
 * `validateSearch` doesn't return, and this route also matches while the
 * embedded app serves the funnel (rollout flag off), so dropping `utm_*`/
 * `gclid`/`signupFlow`/`content` here would corrupt marketing attribution and
 * flow selection before the embedded app even boots. The signup flow's own
 * landing-param capture consumes them too.
 *
 * TanStack Router's default `parseSearch` runs every value through
 * `JSON.parse`, so a numeric-looking `?promoCode=123` arrives as the number
 * `123` — coerce it back rather than dropping it (a dropped key is stripped
 * from the URL entirely).
 */
export function parseSignupSearch(search: Record<string, unknown>): SignupSearch {
  return {
    ...search,
    signupType: typeof search.signupType === 'string' ? search.signupType : undefined,
    promoCode:
      typeof search.promoCode === 'string'
        ? search.promoCode
        : typeof search.promoCode === 'number'
          ? String(search.promoCode)
          : undefined,
  };
}
